import { useMemo } from 'react';
import type { HourlyRate } from '@altyor-kronos/shared-types';
import { usePolledResource } from '../../core/data/usePolledResource';
import { apiList } from '../../core/data/restClient';

/**
 * Read all hourly rates, ordered by label.
 * Used by DesignationDialog so the PM can pick a named rate.
 */
export function useHourlyRatesSnapshot(): HourlyRate[] {
  const { rows } = usePolledResource<HourlyRate & { id: string }>(
    'hourly-rates',
    () => apiList<HourlyRate & { id: string }>('/hourlyRates'),
  );
  // Server list has no orderBy — sort by label.
  return useMemo(() => rows.slice().sort((a, b) => a.label.localeCompare(b.label)), [rows]);
}
